import React from 'react';
import { formatNumber } from '../normalizer';

const CartItemsTable = props => {

  const {
    cart,
    currencyLabel,
    onIncreaseItem,
    onDecreaseItem,
    onRemoveItem,
    checkout,
  } = props

  const editCartItems = !checkout;

  return (
    <table className='g-cart__table mt-6 '>
      <thead className='my-10 text-left'>
        <tr className='w-full vodafone text-sm md:text-lg'>
          <th className="g-cart__number-cell-10">Nº</th>
          <th className="g-cart__number-cell-60">Descrição do artigo</th>
          <th className='text-center g-cart__number-cell-10'>{currencyLabel}</th>
          <th className='text-center w-1/5'>Qts</th>
          <th className='text-center g-cart__number-cell-10'>
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {cart.items.map((item, index ) => {
          return (
            <tr key={item.id} className='g-cart__data text-xs md:text-base my-5'>
              <td className="">{index + 1}</td>
              <td className='g-cart__cell'>{item.product.name}</td>
              <td className="text-center">{formatNumber(item.base_points)}</td>
              <td className="text-center">
                <div>
                  {editCartItems &&
                    <button className="outline-reset" onClick={() => onDecreaseItem(item)}>
                      <i className='fas fa-minus navbar-text'/>
                    </button>
                  }
                  <span className="px-1">{item.quantity}</span>
                  {editCartItems &&
                    <button className="outline-reset" onClick={() => onIncreaseItem(item)}>
                      <i className='fas fa-plus navbar-text'/>
                    </button>
                  }
                </div>
              </td>
              <td className='cart-item__text text-center'>{formatNumber(item.points)}</td>
              {editCartItems &&
                <td className="text-right">
                  <i
                    className='fas fa-trash-alt cursor-pointer'
                    onClick={() => onRemoveItem(item)} />
                </td>
              }
            </tr>
          )
        })}
        <tr className='text-left '>
          <td className='navbar-text vodafone py-5 text-size' colSpan={3}>Total da encomenda</td>
          <td/>
          <td className='text-center'>{formatNumber(cart.total_points)}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default CartItemsTable;
